import React from 'react';
import { Modal, Empty, Spin, Row, Col } from 'antd';
import { BsBookmarkFill } from 'react-icons/bs';
import { IStoryList } from '@coreStory/type';
import StoryCard from '@app/Dashboard/pages/Library/components/WebLibrary/StoryCard';
import MobileStoryCard from '@app/Dashboard/pages/Library/components/MobileLibrary/StoryCard';
import styles from './index.module.scss';

interface RecommendedStoriesModalProps {
  visible: boolean;
  onCancel: () => void;
  recommendedStories: IStoryList[] | null;
  isLoading: boolean;
  error: any;
  isMobile?: boolean;
}

const RecommendedStoriesModal: React.FC<RecommendedStoriesModalProps> = ({
  visible,
  onCancel,
  recommendedStories,
  isLoading,
  error,
  isMobile = false,
}) => {
  const handleStoryClick = () => {
    onCancel();
  };
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.loadingContainer}>
          <Spin size="large" />
          <p>Loading recommended stories...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className={styles.errorContainer}>
          <Empty
            image={<BsBookmarkFill size={48} className={styles.errorIcon} />}
            description={
              <div className={styles.errorDescription}>
                <h3>Error Loading Recommended Stories</h3>
                <p>Failed to load recommended stories. Please try again.</p>
              </div>
            }
          />
        </div>
      );
    }

    if (!recommendedStories || recommendedStories.length === 0) {
      return (
        <div className={styles.emptyContainer}>
          <Empty
            image={<BsBookmarkFill size={48} className={styles.emptyIcon} />}
            description={
              <div className={styles.emptyDescription}>
                <h3>No Recommended Stories</h3>
                <p>No recommended stories available for this story.</p>
              </div>
            }
          />
        </div>
      );
    }

    return (
      <div className={styles.recommendedContent}>
        <div className={styles.recommendedHeader}>
          <div className={styles.iconContainer}>
            <BsBookmarkFill size={24} className={styles.recommendedIcon} />
          </div>
          <h3>Recommended Stories</h3>
          <p>Discover similar stories you might enjoy</p>
        </div>

        <div className={styles.recommendedBody}>
          {isMobile ? (
            <div className={styles.mobileStories}>
              {recommendedStories.map((story, index) => (
                <div
                  key={index}
                  className={styles.mobileStoryItem}
                  onClick={handleStoryClick}>
                  <MobileStoryCard {...story} />
                </div>
              ))}
            </div>
          ) : (
            <Row gutter={[20, 20]} className={styles.storiesGrid}>
              {recommendedStories.map((story, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <div
                    className={styles.storyCardWrapper}
                    onClick={handleStoryClick}>
                    <StoryCard {...story} />
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={isMobile ? '95%' : 1200}
      className={styles.recommendedStoriesModal}
      centered>
      {renderContent()}
    </Modal>
  );
};

export default RecommendedStoriesModal;
